import './Theme.Page.List.scss';
export default 'ThemePageList';
